import React, { useContext, useEffect } from "react";
import "./Signup.css";
import { Button, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { LoadingContext } from "../../context/LoadingContext";
import { TitleContext } from "../../context/TitleContext";
import { routeNames } from "../../constants/routeNames";
import Api from "../../api/Api";

import { errorHandler } from "../../helpers/errorHelper";
import { Controller, useForm } from "react-hook-form";

/**
 * @typedef {Object} FormData
 * @property {string} firstName - The user's first name.
 * @property {string} lastName - The user's last name.
 * @property {string} email - The user's email address.
 * @property {string} county - The user's county.
 * @property {boolean} terms - Whether the user agreed to the terms.
 * @property {boolean} offers - Whether the user opted into marketing.*
 * @property {boolean} greeneKingOffers - Whether the user opted into greene king offers.
 */

/**
 * @returns {JSX.Element} The rendered form.
 */

const initialForm = {
  firstName: "",
  lastName: "",
  email: "",
  county: "",
  terms: false,
  offers: false,
  greeneKingOffers: false,
};

export const Signup = (props) => {
  const navigate = useNavigate();
  const { setTitle } = useContext(TitleContext);
  const { setLoading } = useContext(LoadingContext);

  const { control, handleSubmit } = useForm({ defaultValues: initialForm });

  useEffect(() => {
    setLoading(true);
    setTitle("ENTER");
    Api.checkCampaign()
      .then((response) => {
        if (response?.result && response?.data) {
        } else {
          errorHandler(response, navigate);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  /**
   * @param {FormData} data
   */
  const onSubmit = async (data) => {
    setLoading(true);
    navigate(routeNames.ASKLOCATION, {
      state: {
        redirected: true,
        userData: data,
      },
    });
  };

  return (
    <div>
      <h2 className="title register-title">
        Purchase a Coke and enter your details to get one free for a mate, and
        chances to win music prizes with Share a Coke & Greene King Lucky Sips
      </h2>

      <p className="title" style={{ fontWeight: 400 }}>
        Please note if you're a winner, we'll use the email address supplied to
        send your prize!{" "}
      </p>

      <Form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="firstName"
          control={control}
          defaultValue=""
          rules={{
            required: "First name is required.",
          }}
          render={({ field, fieldState: { error } }) => (
            <Form.Group className="cc-custom-form">
              <Form.Control
                {...field}
                type="text"
                placeholder="First Name"
                className="custom-input"
                name="firstName"
              />
              {error?.message && (
                <p className="field-error">{error?.message}</p>
              )}
            </Form.Group>
          )}
        />

        <Controller
          name="lastName"
          control={control}
          defaultValue=""
          rules={{
            required: "Last name is required.",
          }}
          render={({ field, fieldState: { error } }) => (
            <Form.Group className="cc-custom-form">
              <Form.Control
                {...field}
                type="text"
                placeholder="Last Name"
                className="custom-input"
                name="lastName"
              />
              {error?.message && (
                <p className="field-error">{error?.message}</p>
              )}
            </Form.Group>
          )}
        />

        <Controller
          name="email"
          control={control}
          defaultValue=""
          rules={{
            required: "Email address is required.",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Please enter valid email address.",
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <Form.Group className="cc-custom-form">
              <Form.Control
                {...field}
                type="email"
                placeholder="Email Address"
                className="custom-input"
                name="email"
              />
              {error?.message && (
                <p className="field-error">{error?.message}</p>
              )}
            </Form.Group>
          )}
        />

        <Controller
          name="county"
          control={control}
          defaultValue=""
          rules={{
            required: "County is required.",
          }}
          render={({ field, fieldState: { error } }) => (
            <Form.Group className="cc-custom-form">
              <Form.Control
                {...field}
                type="text"
                placeholder="County"
                className="custom-input"
                name="county"
              />
              {error?.message && (
                <p className="field-error">{error?.message}</p>
              )}
            </Form.Group>
          )}
        />

        <Controller
          name="terms"
          control={control}
          defaultValue=""
          rules={{
            required: "You must agree with our terms and conditions.",
          }}
          render={({ field, fieldState: { error } }) => (
            <Form.Group className="mb-1 pt-2 mx-4 text-start ">
              <label className="checkbox-container">
                <span className="checkbox-content">
                  I have read and agree to the{" "}
                  <Link to={"/terms"} className="checkbox-link" target="_blank">
                    terms & conditions
                  </Link>
                  .
                </span>
                <input type="checkbox" name="terms" onClick={field.onChange} />
                <span className="checkmark"></span>
              </label>
              {error?.message && (
                <p className="field-error">{error?.message}</p>
              )}
            </Form.Group>
          )}
        />

        <Controller
          name="offers"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <Form.Group className="mb-1 pt-2 mx-4 text-start ">
              <label className="checkbox-container">
                <span className="checkbox-content">
                  I agree to the{" "}
                  <Link to={"/terms"} className="checkbox-link" target="_blank">
                    marketing preferences.
                  </Link>
                  .
                </span>
                <input
                  type="checkbox"
                  name="offers"
                  onChange={field.onChange}
                />
                <span className="checkmark"></span>
              </label>
            </Form.Group>
          )}
        />

        <Controller
          name="greeneKingOffers"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <Form.Group className="mb-1 pt-2 mx-4 text-start ">
              <label className="checkbox-container">
                <span className="checkbox-content">
                  I would like to sign-up to receive marketing communications
                  from Greene King and its family of brands.
                </span>
                <input
                  type="checkbox"
                  name="offers"
                  onChange={field.onChange}
                />
                <span className="checkmark"></span>
              </label>
            </Form.Group>
          )}
        />

        <div className="text-center">
          <Button className="cc-button entry-btn" type="submit">
            Next
          </Button>
        </div>
      </Form>
    </div>
  );
};
